import api from '@/services/api';
const ENTITY_ENDPOINT = 'talonario';

export class TalonarioService {
  /**
   * Obtiene todos los talonarios con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los talonarios con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Busca talonarios por nombre o criterio
   * @param {string} query - Término de búsqueda
   * @param {Object} additionalParams - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async search(query, additionalParams = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/`, {
      params: {
        Nombre: query,
        ...additionalParams,
      },
    });
  }

  /**
   * Obtiene un talonario por su ID
   * @param {string|number} id - ID del talonario
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo talonario
   * @param {Object} talonario - Datos del talonario a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(talonario) {
    return await api.post(`/${ENTITY_ENDPOINT}`, talonario);
  }

  /**
   * Actualiza un talonario existente
   * @param {string|number} id - ID del talonario
   * @param {Object} talonario - Datos del talonario a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, talonario) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, talonario);
  }

  /**
   * Elimina un talonario
   * @param {string|number} id - ID del talonario
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default TalonarioService;
